document.addEventListener('DOMContentLoaded', function() {
    iniciarMenu();
});

function iniciarMenu() {
    const hamburguesa = document.querySelector('#hamburguesa');
    const navegacion = document.querySelector('.navegacion');
    const enlaces = document.querySelectorAll('.navegacion__enlace');

    if (!hamburguesa || !navegacion) return;

    hamburguesa.addEventListener('click', function() {
        const estaAbierto = navegacion.classList.toggle('mostrar');

        hamburguesa.setAttribute('aria-expanded', estaAbierto ? 'true' : 'false');
        hamburguesa.setAttribute(
            'aria-label',
            estaAbierto ? 'Cerrar menú de navegación' : 'Abrir menú de navegación'
        );

        const icono = hamburguesa.querySelector('i');
        if (icono) {
            if (estaAbierto) {
                icono.classList.remove('fa-bars');
                icono.classList.add('fa-xmark');
            } else {
                icono.classList.remove('fa-xmark');
                icono.classList.add('fa-bars');
            }
        }
    });

    enlaces.forEach(enlace => {
        enlace.addEventListener('click', function() {
            if (document.body.clientWidth < 1024) {
                navegacion.classList.remove('mostrar');
                hamburguesa.setAttribute('aria-expanded', 'false');
                hamburguesa.setAttribute('aria-label', 'Abrir menú de navegación');

                const icono = hamburguesa.querySelector('i');
                if (icono) {
                    icono.classList.remove('fa-xmark');
                    icono.classList.add('fa-bars');
                }
            }
        });
    });

    window.addEventListener('resize', function() {
        if (document.body.clientWidth >= 1024) {
            navegacion.classList.remove('mostrar');
            hamburguesa.setAttribute('aria-expanded', 'false');
            hamburguesa.setAttribute('aria-label', 'Abrir menú de navegación');

            const icono = hamburguesa.querySelector('i');
            if (icono) {
                icono.classList.remove('fa-xmark');
                icono.classList.add('fa-bars');
            }
        }
    });
}